import { lazy } from "react"

export const FuelTypePage = lazy(() => import("./FuelTypePage"))
